import DetailsSummaryContainer from './DetailsSummaryContainer';

export {
  DetailsSummaryContainer
};
